import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SurveyCard } from '../states/surveys/survey-card';

export interface EcorrEvent {
    orgId?: number,
    tabChanged?: boolean,
    sendMessageLoaded?: boolean,
    surveyAdded?: boolean,
    surveyInstanceId?: number,
    canisterTriggered?: CanisterEventData
}

export interface CanisterEventData {
    surveys?: SurveyCard[],
    surveyId?: number,
    canisterCode?: number,
    trigger: string
}

@Injectable({
    providedIn: 'root'
})
export class EventService {

    private event = new BehaviorSubject<EcorrEvent>({});

    emitEvent(event: EcorrEvent) {
        this.event.next(event);
    }

    eventListner() {
        return this.event.asObservable();
    }
}
